import { Trans } from '~/common/context';
import { Col, Text } from '@wyz/ui';
import { IUserCustomer } from '~/common/types';
import { QuoteProductResult } from '~/purchase/components';
import { IQuoteSetting, IQuoteTyreOffer } from '~/purchase/types';
import { SEGMENT_NAME } from '~/common/translators';

type Props = {
  items: Array<IQuoteTyreOffer>;
  quoteSetting: IQuoteSetting;
  customer: IUserCustomer;
  pointOfSaleView: boolean;
  requestedQuantity: number;
  onRefreshTyre: (ean: string, quantity: number) => void;
};

// Note: Spec requires the segments to be in this order and to be static
const SEGMENTS = ['PREMIUM', 'QUALITY', 'BUDGET'] as const;

function QuoteColumnarDisplay({
  items,
  quoteSetting,
  customer,
  pointOfSaleView,
  requestedQuantity,
  onRefreshTyre,
}: Props) {
  const groupedItems = items.reduce(
    (acc, item) => {
      const segment = item.tyre.segment.name;
      if (!acc[segment]) {
        acc[segment] = [];
      }
      acc[segment].push(item);
      return acc;
    },
    {} as Record<string, IQuoteTyreOffer[]>,
  );

  return (
    <div className='grid gap-2'>
      {SEGMENTS.map((segment) => {
        const offers = groupedItems[segment] ?? [];
        return (
          <Col key={segment} bsPrefix='g-col' lg={4}>
            <div className='rounded bg-white p-1 mb-2'>
              <Text
                color='tertiary-bold'
                weight='semi-bold'
                className='text-center'
              >
                <Trans i18nKey={SEGMENT_NAME[segment]} />
              </Text>
            </div>
            <div
              className='space-y-2'
              style={{
                maxHeight: '100vh',
                overflow: 'auto',
              }}
            >
              {offers.length === 0 && (
                <Text className='text-center'>
                  <Trans i18nKey='app.purchase.quote_search_page.empty_segment' />
                </Text>
              )}
              {offers.map((offer) => (
                <QuoteProductResult
                  key={offer.tyre.ean}
                  pointOfSaleView={pointOfSaleView}
                  tyreOffer={offer}
                  defaultQuantity={requestedQuantity}
                  customer={customer}
                  showBfDiscount={quoteSetting.showBfDiscount ?? true}
                  onRefreshTyre={onRefreshTyre}
                />
              ))}
            </div>
          </Col>
        );
      })}
    </div>
  );
}

export default QuoteColumnarDisplay;
